import React from "react";
import "../App.css";

const Error = () => {
  return (
    <div className="error--container">
      <div>
        <i class="fas fa-exclamation-triangle fa-10x" />
        <p>Sorry for the interruption. The link will be back soon.</p>
      </div>
    </div>
  );
};

export default Error;
